import React, { useEffect, useState } from 'react'
import {
  DatePickerControl,
  TimePickerControl,
} from 'src/editor/shared/ui-lib/date-time-picker'
import { ModalWindow } from 'src/editor/shared/ui-lib/modal-window'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

interface SchedulePostModalProps {
  isOpened: boolean
  initialDateTime?: Date
  onClose: () => void
  onSubmit: (scheduledAt: Date) => void
}

export const SchedulePostModal = ({
  isOpened,
  initialDateTime,
  onClose,
  onSubmit,
}: SchedulePostModalProps) => {
  const { t } = useTypedTranslation()
  const [scheduledAt, setScheduledAt] = useState<Date>(
    initialDateTime ?? new Date(),
  )

  useEffect(() => {
    if (!isOpened) {
      return
    }
    setScheduledAt(initialDateTime ?? new Date())
  }, [isOpened, initialDateTime])

  const handleSubmit = () => {
    onSubmit(scheduledAt)
  }

  return (
    <ModalWindow
      isOpened={isOpened}
      onClose={onClose}
      title={t('website_settings.sidebar.blog.schedule_post_modal.title')}
      cancelButtonProps={{
        children: t('global.cancel'),
        onClick: onClose,
      }}
      confirmButtonProps={{
        children: t(
          'website_settings.sidebar.blog.schedule_post_modal.submit_button',
        ),
        onClick: handleSubmit,
      }}
    >
      <div className="flex gap-3">
        <div className="flex flex-1 flex-col gap-1">
          <span className="font-medium text-S text-textPrimary">
            {t('website_settings.sidebar.blog.schedule_post_modal.date_label')}
          </span>
          <DatePickerControl
            dateTime={scheduledAt}
            updateDate={setScheduledAt}
          />
        </div>
        <div className="flex flex-1 flex-col gap-1">
          <span className="font-medium text-S text-textPrimary">
            {t('website_settings.sidebar.blog.schedule_post_modal.time_label')}
          </span>
          <TimePickerControl
            dateTime={scheduledAt}
            updateDate={setScheduledAt}
            showDate={true}
            minuteInterval={15}
          />
        </div>
      </div>
    </ModalWindow>
  )
}
